import { render, staticRenderFns } from "./BadgeSelector.vue?vue&type=template&id=1d89909f&"
import script from "./BadgeSelector.vue?vue&type=script&lang=js&"
export * from "./BadgeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports